__webpack_require__.p = "/github-activity-report/";